import React, { useState ,useRef} from 'react';
import './gallery.css';
import apj from '../assets/galleryimages/apj-akbs.jpg';
import nsr from '../assets/galleryimages/nilam-sanjeeva-akbs.jpg';
import vvg from '../assets/galleryimages/vv-giri-mammen-mathew.jpg';
import ipn from '../assets/galleryimages/indira-gandhi-akbs.jpg';
import st1 from '../assets/galleryimages/state leadership camp.jpg';
import PTA1 from '../assets/galleryimages/Praatheeksha_nature_camp.jpg';
import VOH1 from '../assets/galleryimages/Visiting old-age home.jpg';
import PTA2 from '../assets/galleryimages/pratheeksha_natue_Camp_pTA.jpg';
import PTA3 from '../assets/galleryimages/pratheeksha camp.jpg';
import MGXP1 from '../assets/galleryimages/magic_plannet.jpg';
import MGXP2 from '../assets/galleryimages/magic_plannet2.jpg';
import OCH from '../assets/galleryimages/STATE_leaders_paying_homege_formr Cm.jpg'
import PSC from '../assets/galleryimages/BALAJANA_SAKHYAM_PEECHI_CAMP_GROUP_DSC_2918.jpg';
import PSC1 from '../assets/galleryimages/statecamp2.JPG';
import PSC2 from '../assets/galleryimages/statecmp1.JPG';
import PSC3 from '../assets/galleryimages/Peechi_camp.jpg';
import PNC from '../assets/galleryimages/pratheeksha_natue_Camp_pTA.jpg';
import JIM1 from '../assets/galleryimages/JIM_6737.jpg';
// import JIM2 from '../assets/galleryimages/JIM_6755.jpg';
import JIM3 from '../assets/galleryimages/JIM_6795.jpg';
import HP2011 from '../assets/galleryimages/2011 kottayam Hrudayapoorvam Sak.jpg'
import BC12 from '../assets/galleryimages/2012 Balajanasakhyam Camp .jpg'
import AKBSCI from '../assets/galleryimages/Akhila Kerala Balajanasakhyam ci(1).jpg'
import ANITAB from '../assets/galleryimages/Anita Bose.jpg'
import AKBSPC from '../assets/galleryimages/Akhila Kerala Balajanasakhyam PC.jpg'
import AKBSNAV from '../assets/galleryimages/Balajanasakhyam Navathy(1).jpg'
import AKBSNAV1 from '../assets/galleryimages/Balajanasakhyam Navathy.jpg'
import CSC2025_1 from '../assets/galleryimages/ARA_5448.jpg'
import CSC2025_2 from '../assets/galleryimages/ARA_5564.jpg'
import CSC2025_3 from '../assets/galleryimages/ARA_5578.jpg'
import CSC2025_4 from '../assets/galleryimages/ARAA_4987.jpg'



const images = [
  { src: apj, alt: 'APJ Abdul Kalam at AKBS', description: 'APJ Abdul Kalam at AKBS event', date: '2002' },
  { src: nsr, alt: 'Nilam Sanjeeva Reddy at AKBS', description: 'Nilam Sanjeeva Reddy at AKBS', date: '1980' },
  { src: ipn, alt: 'Indira Gandhi at AKBS', description: 'Indira Gandhi addressing AKBS', date: '1976' },
  { src: vvg, alt: 'VV Giri and Mammen Mathew', description: 'VV Giri with Mammen Mathew', date: '1972' },
  { src: JIM1, alt: 'Sakhyam 94th Birth Day Celebration ', description: ' Sakhyam 94th Birth Day Celebration ', date: '' },
  { src: JIM3, alt: 'State Swearing-in Ceremony 2023–24', description: ' State Swearing-in Ceremony 2023–24', date: '' },

  { src: st1, alt: ' State Leadership Camp', description: 'State Leadership camp 2023-24', date: '2024' },
  { src: PTA1, alt: 'Pratheeksha Nature Camp 2023-24', description: 'Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: VOH1, alt: "Visiting oldage home on sakhyam's Birthday", description: "Visiting oldage home on sakhyam's Birthday, Ernakulam", date: '2002' },
  { src: PTA2, alt: 'Pratheeksha Nature Camp 2023-24', description: 'Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: PTA3, alt: 'Pratheeksha Nature Camp 2023-24', description: 'Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: MGXP1, alt: 'MAGIC PLANNET VISIT 2023-24', description: 'Magic Plannet Visit 2023-24', date: '2024' },
  { src: MGXP2, alt: 'MAGIC PLANNET VISIT 2023-24', description: 'Magic Plannet Visit 2023-24', date: '2024' },
  { src: OCH, alt: 'State leaders paying homage to former Chief Minister', description: 'State leaders paying homage to former Chief Minister Shri Oommen Chandy', date: '2023' },
  { src: PSC, alt: 'Peechi State Camp 2024', description: ' State Camp , Peechi,Thrissur 2023-24', date: '2024' },
  { src: PSC1, alt: 'Pratheeksha Nature Camp', description: ' Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: PSC2, alt: 'Pratheeksha Nature Camp', description: ' Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: PSC3, alt: 'Peechi State Camp 2024', description: ' State Camp, Peechi,Thrissur 2023-24', date: '2024' },
  { src: PNC, alt: 'Peechi State Camp 2024', description: ' Pratheeksha Nature Camp 2023-24', date: '2024' },
  { src: HP2011, alt: ' Hridhayapoorvam Sakhyam – Medical Checkup Camp at Kottayam', description: '  Hridhayapoorvam Sakhyam – Medical Checkup Camp at Kottayam', date: '2011' },
  { src: BC12, alt: 'Manorama Balajanasakhyam Camp at Kottayam', description: 'Manorama Balajanasakhyam Camp at Kottayam', date: '' },
  { src: AKBSCI, alt: 'Civil Service Camp 2025 ', description: ' Civil Service Camp 2025 ', date: '2024' },
  { src: AKBSPC, alt: 'pc alexander memmorial elocution competition winners 2024', description: 'Winners – P.C. Alexander Memorial Elocution Competition 2024', date: '2024' },
  { src: ANITAB, alt: 'Anita Bose’s Visit to Manorama Balajanasakhyam — Accompanied by Former State President Oommen Chandy', description: ' Anita Bose’s Visit to Manorama Balajanasakhyam — Accompanied by Former State President Oommen Chandy', date: '' },
  { src: AKBSNAV, alt: 'Balajanasakhyam Navathi Inauguration Function — Former Vice President Venkaiah Naidu', description: ' Balajanasakhyam Navathi Inauguration Function — Former Vice President Venkaiah Naidu', date: '2019' },
  { src: AKBSNAV1, alt: 'Vice President Venkaiah Naidu with State Leaders', description: ' Vice President Venkaiah Naidu with State Leaders', date: '' },
  { src: CSC2025_1, alt: 'AKhila Kerala Balajanasakhyam Civil Servicce Camp 2025', description: ' Civil Servicce Camp ', date: '2025' },
  { src: CSC2025_2, alt: 'AKhila Kerala Balajanasakhyam Civil Servicce Camp 2025', description: ' Civil Servicce Camp ', date: '2025' },
  { src: CSC2025_3, alt: 'AKhila Kerala Balajanasakhyam Civil Servicce Camp 2025', description: ' Civil Servicce Camp ', date: '2025' },
  { src: CSC2025_4, alt: 'Civil Service Camp Award Winners', description: ' Civil Service Camp Award Winners ', date: '2025' },

];


const IMAGES_PER_PAGE = 12;

function Gallery() {
  const [fullscreenImage, setFullscreenImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const galleryRef = useRef(null); // 👈 create a ref

  const openFullscreen = (image) => {
    setFullscreenImage(image);
  };

  const closeFullscreen = () => {
    setFullscreenImage(null);
  };

  const totalPages = Math.ceil(images.length / IMAGES_PER_PAGE);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    galleryRef.current?.scrollIntoView({ behavior: 'smooth' }); // 👈 scroll to gallery
  };

  const paginatedImages = images.slice(
    (currentPage - 1) * IMAGES_PER_PAGE,
    currentPage * IMAGES_PER_PAGE
  );

  return (
    <div className="gallery-page" ref={galleryRef}> {/* 👈 attach ref here */}
      <h1 className="gallery-heading">IMAGE GALLERY</h1>
      <div className="gallery-container">
        {paginatedImages.map((image, index) => (
          <div key={index} className="gallery-item" onClick={() => openFullscreen(image)}>
            <img src={image.src} alt={image.alt} />
            <div className="gallery-description">
              <p className="description-text">{image.description}</p>
              <p className="gallery-date">{image.date}</p>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}

      {fullscreenImage && (
        <div className="fullscreen-overlay" onClick={closeFullscreen}>
          <div className="fullscreen-content">
            <img src={fullscreenImage.src} alt={fullscreenImage.alt} className="fullscreen-img" />
            <div className="fullscreen-description">
              <h2>{fullscreenImage.description}</h2>
              <p className="fullscreen-date">{fullscreenImage.date}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
